// Search presentation text, never internal IDs, flags, or serialized game state.
const textField = /^(name|title|text|.*description|effect|abilities|additionalInfo|rumorPassCondition|rumorPassReward|rumorFailCondition|rumorFailPenalty|otherWorld|startingLocation)$/i;

export const wikiSearchText = (value: unknown): string => {
  if (!value || typeof value !== 'object') return '';
  return Object.entries(value).flatMap(([key, entry]) => {
    if (typeof entry === 'string') return textField.test(key) ? [entry, entry.replace(/([a-z])([A-Z])/g, '$1 $2')] : [];
    if (Array.isArray(entry)) return entry.map(item => typeof item === 'string'
      ? textField.test(key) ? item : '' : wikiSearchText(item));
    return typeof entry === 'object' ? [wikiSearchText(entry)] : [];
  }).join('\n');
};

export const matchesWikiSearch = (text: string, query: string): boolean =>
  text.replace(/<[^>]*>/g, '').replace(/[*_`#]/g, '').toLocaleLowerCase().includes(query.trim().toLocaleLowerCase());
